import { TranslatePipe } from '../../filters/translate.pipe';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import { Component, OnInit, inject, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import Config from '../../utils/config.service';
import Session from '../../utils/session.service';
import UserRestServices from '../../services/user-rest.service';
import BookingService from '../../services/booking.service';
import AngularHelperService from '../../services/angular-helper.service';
import AngularRoutingHelperService from '../../services/angular-routing-helper.service';
import RoutingService from '../../services/routing.service';
import moment from 'moment';
import { MatSelectModule } from '@angular/material/select';
import { PanelDirective } from '../../directives/panel.directive';

@Component({
	standalone: true,
	selector: 'booking-address',
	templateUrl: './booking-address.component.html',
	imports: [
		CommonModule, PanelDirective, MatSelectModule, TranslatePipe, 
		LoaderOverlayComponent, FormsModule, RouterLink
	]
})
export default class BookingAddressView implements OnInit, OnDestroy {
	private config: Config = inject(Config);
	private session: Session = inject(Session);
	private userRestServices: UserRestServices = inject(UserRestServices);
	private bookingService: BookingService = inject(BookingService);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularRoutingHelperService: AngularRoutingHelperService = inject(AngularRoutingHelperService);
	private routingService: RoutingService = inject(RoutingService);
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
		
	}
	
	ngOnInit() {
		this.routingService.validateAccess('booking').then(() => {
			var serviceId: any = this.angularRoutingHelperService.getCurrentRouteParam('serviceId');
			this.bookingService.getUnfinishedBooking(Number(serviceId))
				.then((booking) => {
					if (!booking) {
						this.angularRoutingHelperService.setPath(['booking/service/', serviceId], false, true);
					} else if (!booking.service.customerContactAddressRequired) {
						this.angularRoutingHelperService.setPath(['booking/service/', serviceId, 'checkout'], false, true);
					} else {
						this.onResolve(booking);
					}
				});
		});
	}
	
	ngOnDestroy() {
		if (this.vm.expiryInterval) this.angularHelperService.cancelInterval(this.vm.expiryInterval);
	}
	
	onResolve(booking) {
		this.vm.booking = booking;
		this.vm.user = this.session.getSession().user;
		this.vm.countries = this.config.getCountries();
		this.vm.serviceId = this.angularRoutingHelperService.getRouteParam('serviceId');
		this.vm.address = {
			country: 'Estonia',
		};
		this.vm.isPanelOpen = true;
		this.getAddress();
		this.startExpiryTimer(new Date(this.vm.booking.bookingStart));
		
		this.vm.getCounties = this.getCounties;
		this.vm.handleFormSubmit = this.handleFormSubmit;
	}
	
	getAddress() {
		this.userRestServices.getContactInfo((res) => {
			if (res && res.id) {
				this.vm.address = res;
			}
			this.getCounties();
			this.vm.initialized = true;
		});
	}
	
	getCounties() {
		this.vm.address = this.vm.address || {};
		this.vm.counties = this.config.getCounties(this.vm.address.country);
		if (this.vm.address.country == 'Estonia') {
			if (!this.vm.address.county || this.vm.counties.indexOf(this.vm.address.county) < 0) {
				this.vm.address.county = this.vm.counties[0];
			}
		} else {
			this.vm.address.county = this.vm.address.county || null;
		}
	}
	
	handleFormSubmit(mainForm: any) {
		this.vm.submitted = true;
		
		if (!this.vm.address.country) {
			this.vm.countryInvalid = true;
		} else {
			this.vm.countryInvalid = false;
		}
		
		if (this.vm.countryInvalid || mainForm.invalid || this.vm.isProcessing || this.vm.isExpired) {
			this.vm.isPanelOpen = true;
			return;
		}
		this.vm.isProcessing = true;
		this.userRestServices.updateContactInfo(this.vm.address, (res) => {
			this.angularRoutingHelperService.setPath(['booking/service/', this.vm.serviceId, 'checkout']);
		});
	}
	
	startExpiryTimer(startedAt) {
		this.vm.expiryTimerStartedAt = moment(new Date(startedAt)).add(15 * 60, 'seconds');
		if (this.vm.expiryInterval) this.angularHelperService.cancelInterval(this.vm.expiryInterval);
		this.vm.isExpired = moment() > this.vm.expiryTimerStartedAt;
		this.vm.expiresIn = moment() < this.vm.expiryTimerStartedAt
			? moment.utc(moment(this.vm.expiryTimerStartedAt).diff(moment())).format('mm:ss')
			: undefined;
		
		this.vm.expiryInterval = this.angularHelperService.createInterval(() => {
			this.checkExpiry();
		}, 1000);
	}
	
	checkExpiry() {
		if (moment() > this.vm.expiryTimerStartedAt) {
			this.vm.isExpired = true;
			this.angularHelperService.cancelInterval(this.vm.expiryInterval);
		} else {
			this.vm.expiresIn = moment.utc(moment(this.vm.expiryTimerStartedAt).diff(moment())).format('mm:ss');
		}
	}
	
}